import { render, staticRenderFns } from "./IntermediateItem.vue?vue&type=template&id=457a52f9&scoped=true"
import script from "./IntermediateItem.vue?vue&type=script&lang=js"
export * from "./IntermediateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a52f9",
  null
  
)

export default component.exports